import type { SessionTask } from '../type';

export function getTaskById(
  taskId: SessionTask['id'],
  tasks: SessionTask[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  caller: string,
): SessionTask | undefined {
  const task = tasks.find(({ id }) => id === taskId);
  if (task === undefined) {
    // TODO ha fix a rendszer kossuk vissza
    // console.error(`[SessionState::${caller}] Not found task! => ${taskId}`);
  }

  return task;
}
